import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type IndiceIpcAyudaDialogProps = {
  open: boolean;
  onClose: () => void;
};

const IndiceIpcAyudaDialog: React.FC<IndiceIpcAyudaDialogProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ pr: 6, position: 'relative' }}>
      Nivel del índice vs variación del mes
      <IconButton
        aria-label="Cerrar ayuda del índice"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          Podés cargar el <strong>nivel absoluto del IPC</strong> o la <strong>variación % del mes</strong>.
          El sistema siempre guarda el nivel; si cargás variación, la convierte con el mes anterior.
        </Typography>
        <Typography variant="body1">
          <strong>Ejemplo</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Dic-2025: nivel <strong>100</strong>
          <br />
          Ene-2026: variación <strong>2,5 %</strong> → el sistema guarda <strong>102,5</strong>
          <br />
          Feb-2026: nivel <strong>105,1</strong> (también válido)
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Fórmula: nivel = nivel del mes anterior × (1 + variación / 100).
          En el Excel, completá la columna Índice o la de Variación %; si ambas tienen dato, gana el Índice.
        </Typography>
        <Typography variant="body1">
          <strong>Requisito</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          El primer mes de una serie con variación necesita un nivel de base ya cargado
          (manual, Excel o un mes anterior en el mismo archivo).
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained" sx={{ textTransform: 'none' }}>
        Entendido
      </Button>
    </DialogActions>
  </Dialog>
);

export default IndiceIpcAyudaDialog;
